import { keyframes } from '@mui/material';

export const EASE_STANDARD = 'cubic-bezier(0.4, 0, 0.2, 1)';
export const EASE_ACCELERATE = 'cubic-bezier(0.4, 0, 1, 1)';
export const EASE_DECELERATE = 'cubic-bezier(0, 0, 0.2, 1)';

export const FADE_IN_SM = keyframes`
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const FADE_IN_MD = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const MODAL_SCALE_IN = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const MENU_POP_IN = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const FADE_IN = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const FADE_IN_X = keyframes`
  from { opacity: 0; transform: translateX(-4px); }
  to { opacity: 1; transform: translateX(0); }
`;

export const MENU_IN_UP = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const MENU_IN_DOWN = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const SLIDE_UP = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const PANEL_IN = keyframes`
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

/** Row highlight fade-out; the caller supplies `--pulse-bg`. */
export const ROW_PULSE = keyframes`
  0% { background-color: var(--pulse-bg); }
  100% { background-color: transparent; }
`;

/** Row highlight fade-out; the caller supplies `--added-flash-bg`. */
export const ADDED_FLASH = keyframes`
  from { background-color: var(--added-flash-bg); }
  to { background-color: transparent; }
`;

export const CONFIRM_FADE_IN_MS = 240;

export const CONFIRM_FADE_IN = keyframes`
  from { opacity: 0; max-height: 0; padding-top: 0; padding-bottom: 0; }
  to { opacity: 1; max-height: 64px; padding-top: 10px; padding-bottom: 10px; }
`;

export const CHIP_PULSE_KEYFRAMES: Keyframe[] = [
  { transform: 'scale(1)' },
  { transform: 'scale(1.07)', offset: 0.35 },
  { transform: 'scale(0.98)', offset: 0.65 },
  { transform: 'scale(1)' },
];

export const CHIP_PULSE_OPTIONS: KeyframeAnimationOptions = { duration: 560, easing: EASE_STANDARD };
